<template>
    <div class="card">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fab fa-telegram-plane mr-2"></i>Comunicación Multiasistencia &nbsp;
            </h3>
              <div class="card-tools d-flex align-items-center" v-show="mostrarminimizaraux">
                            <button type="button" id="botonmin" class="btn btn-tool ampliar-asegurado" data-card-widget="collapse" @click="minimizarpulsar" title="Minimizar">
                    <i class="fas fa-eye"></i>
                </button>

                        </div>
        </div>
        <div class="card-body">
                        <!--INICIO LISTA GREMIOS-->
            <div class="row" v-if="gremios" :class="clasegremio">
                <div class="col-md-12">
                    <table class="table table-striped table-valign-middle">
                        <thead>
                            <tr>
                                <th v-for="columna in gremios.gremios.encabezado" :key="columna">{{ columna }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="filas in gremios.gremios.filas" :key="filas">
                                <td style="padding:0.3rem" v-for="fila in filas" :key="fila">
                                    <div v-if="fila.campos">
                                        <div v-for="(campo, index) in fila.campos" :key="campo">
                                            <label style="margin-bottom:0rem;vertical-align:top" class="btn active"
                                                v-if="campo.tipo == 'radio'">
                                                <input @click="seleccionarGremio(fila)" class="defecto"
                                                    v-if="campo.valor == fila.campos[0].valor" type="radio"
                                                    name="opcionesGremio" :id="campo.valor" autocomplete="off" />
                                                <input @click="seleccionarGremio(fila)"
                                                    :class="'prestacion' + index"
                                                    style="margin-bottom:0rem;vertical-align:top" v-else type="radio"
                                                    name="opcionesGremio" :id="campo.valor" autocomplete="off" />
                                                {{ campo.desc }}
                                            </label>
                                        </div>
                                    </div>
                                    <div v-if="!fila.campos">
                                        <p style="margin-bottom: 0px;" v-html="fila"></p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div><!--FIN TABLA LISTA GREMIOS-->
            <div>
              
            <iframe :src="direccioncomputed" width="100%" height="615px"  frameborder="0"  ></iframe>
            
            </div>
        </div>
    </div>
    
   
</template>
<script>

export default ({
            props: ['id', 'cargar', 'servicio','tipocargado','minimizarprop'],
    setup() {
        return;
    },
    components: {
      
    },
      data() {
        return {
            direccionglobal:  localStorage.getItem('direccion'),
                        repetiraux:0,


        }
    },
    methods: {

  minimizarpulsar(){
            if(this.repetiraux==0){
                            this.$parent.$parent.minimizar();
                            this.repetiraux=1;

            }
            setTimeout(() => {
                this.repetiraux=0;
            }, 500);
        },
        async seleccionarGremio(valor) {
           console.log('valor',valor);
        },
      
   
    },
    computed:{
       direccioncomputed(){
        if(this.direccionglobal == 'null.pwgs.app'){
            return "https://desarrollofront.pwgs.app/modulos/multiasistencia/modulo_multiasistencia.php?id_gremio=" + this.$props.id + "&tipo=" + this.$props.tipocargado;
        }
        else{
            return "https://" + this.direccionglobal + "/modulos/multiasistencia/modulo_multiasistencia.php?id_gremio=" + this.$props.id + "&tipo=" + this.$props.tipocargado;
        }
       }
    },
    watch: {
       
        

    },
    mounted(){
       

        
    },
    activated(){
    },
     
})



</script>
